import Mutations from '../../odata/mutations';

export default { ...new Mutations('feedbackItem'), ...new Mutations('feedbackItems') };
